import { HighContrastSelector, ICellStyleProps, IContextualMenuStyles, IDetailsColumnStyles, IDetailsListStyles, IStackStyles, Theme } from "@fluentui/react";

export const contextualMenuGapSpace = 10;
export const columnHeaderDefaultMinWidth = "300px";
export const headerListItemPadding = "8px 0 8px 2px";

export const headerCellStyle: ICellStyleProps = {
    cellLeftPadding: 0,
    cellRightPadding: 0,
    cellExtraRightPadding: 0
};

// Styles for DetailsList Stack wrapper which control the horizontal scroll bar
export const getStackWrapperStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            width: "100%",
            overflowX: "auto"
        }
    };
};

// Styles for overall DetailsList component (passed to FluentUI's DetailsList)
export const getDetailsListStyles = (theme: Theme): Partial<IDetailsListStyles> => {
    return {

        // Styles needed for allowing columnHeader to stretch to maximum height
        headerWrapper: {
            "[role=row] > div": {
                display: "flex",
                flexGrow: 1,
                // The following divs map to Stack, StackItem, and Stack
                "div ": {
                    alignItems: "stretch", // required for MobileListItem headers
                    "div > div": {
                        height: "100%",
                        maxWidth: "100%" // ensures width of ColumnHeader does not exceed stack's width
                    }
                }
            }
        },
        contentWrapper: {
            "[role=row]": {
                ":hover": {
                    backgroundColor: theme.palette.neutralLighterAlt,
                    outline: `1px solid ${theme.palette.neutralLighterAlt}`
                },
                ":active": {
                    backgroundColor: theme.palette.neutralLight,
                    outline: `1px solid ${theme.palette.neutralLight}`
                },
                ":hover:active": {
                    backgroundColor: theme.palette.neutralLight,
                    outline: `1px solid ${theme.palette.neutralLight}`
                }
            }
        }
    };
};

// Styles for custom DetailList headers
export const getDetailsColumnStyles = (index: number, isIconOnly: boolean, headerContainsListItem?: boolean): Partial<IDetailsColumnStyles> => {
    let defaultStyles;
    // Styles for centering header titles that only contain icons
    if (isIconOnly) {
        defaultStyles = {
            flexFlow: "column wrap-reverse",
            justifyContent: "center"
        };
    }

    return {
        root: {
            width: headerContainsListItem ? "fit-content !important" : undefined,
            "[role=button]": {
                [HighContrastSelector]: {
                    ":hover": {
                        outline: "1px solid Highlight"
                    },
                    ":active:hover": {
                        outline: "1px solid Highlight"
                    }
                }
            },
        },
        cellTooltip: {
            position: "relative",
            height: "100%",
            width: "100%"
        },
        cellTitle: {
            whiteSpace: "normal",
            alignItems: "center",
            height: "100%",
            width: "100%",
            paddingRight: "2px",
            // The first header title needs extra padding
            paddingLeft: index === 0 ? "12px" : "8px",
            ...defaultStyles
        }
    };
};

// Styles for headers that only contain ListItems
export const detailsListItemHeaderColumnStyle: Partial<IDetailsColumnStyles> = {
    root: {
        width: "100% !important"
    }
};

export const getContextualMenuStyles = (theme: Theme): Partial<IContextualMenuStyles> => {
    return {
        list: {
            backgroundColor: theme.semanticColors.buttonBackground
        }
    };
};

// Styles applied to column headers that contain interactive and sortable listItemColumns as content
export const listItemHeaderStackStyles: Partial<IStackStyles> = {
    root: {
        alignItems: "center",
        marginRight: "8px"
    }
};

export const getScrollablePaneStackStyles = (customHeight: string | number): Partial<IStackStyles> => {
    return {
        root: {
            height: customHeight,
            position: "relative",
            overflow: "unset"
        }
    };
};
